import axios from 'axios'

export default () => {
    return {
        api: '',
        currentPage: 1,
        filters: {
            category: {
                selected: ['all'],
                selections: [],
            },
            type: {
                selected: 'all',
                selections: [],
            },
            sort: {
                selected: 'date_dsc',
            },
        },
        filterOpen: false,
        filtered: true,
        finished: false,
        items: [],
        perPage: 12,
        proxy: null,
        search: null,
        pinnedItems: [],
        pinnedIds: [],
        isLoading: true,

        // π ----
        // :: MOUNTED ---------------------------::
        // ____
        mounted() {
            this.filters.category.selected = ['all']
            this.api = `${this.proxy}/wp-admin/admin-ajax.php`
            this.fetchEntries()
            this.filterInit()
        },

        isUnfiltered() {
            var categoryDefault = this.filters.category.selected.length === 1 && this.filters.category.selected[0] === 'all'
            var typeDefault = this.filters.type.selected === 'all'
            var sortDefault = this.filters.sort.selected === 'date_dsc'
            var noSearch = !this.search
            return categoryDefault && typeDefault && sortDefault && noSearch
        },

        getDisplayItems() {
            if (this.isUnfiltered() && this.pinnedItems.length > 0) {
                return this.pinnedItems.concat(this.items)
            }
            return this.items
        },

        openGrid(onComplete) {
            const open = new TimelineMax({ onComplete: onComplete })

            open.to(this.$refs.cardGrid, 0.5, {
                height: this.$refs.cardGrid.scrollHeight,
                ease: Quint.easeInOut,
            }).to(this.$refs.gridCover, 0.3, {
                autoAlpha: 0,
            })
        },

        closeGrid(onComplete) {
            const close = new TimelineMax({ onComplete: onComplete })
            close.to(this.$refs.gridCover, 0.3, { autoAlpha: 1 }).to(this.$refs.cardGrid, 0.5, {
                height: 264,
                ease: Quint.easeInOut,
            })
        },

        // π ----
        // :: FETCH ENTRIES ---------------------------::
        // ____
        fetchEntries() {
            const requestData = new FormData()

            requestData.append('action', 'blogFetch')
            requestData.append('page', this.currentPage)
            requestData.append('per_page', this.perPage)

            // :: Filters ------------ //
            requestData.append('filter_category', this.filters.category.selected)
            requestData.append('filter_type', this.filters.type.selected)
            requestData.append('filter_sort', this.filters.sort.selected)
            if (this.search) {
                requestData.append('search_term', this.search)
            }
            if (this.isUnfiltered() && this.pinnedIds.length > 0) {
                requestData.append('exclude_ids', this.pinnedIds.join(','))
            }

            this.anyMore()

            axios
                .post(this.api, requestData)
                .then(response => {
                    if (response.data.entries != '') {
                        const entries = response.data.entries
                        if (this.filtered) {
                            this.items = entries
                            this.filtered = false
                        } else {
                            const mergedItems = this.items.concat(entries)
                            this.items = mergedItems
                        }
                        this.updatePage()
                    } else {
                        this.finished = true
                    }

                    this.$nextTick(() => {
                        this.openGrid(() => {
                            this.isLoading = false
                        })
                    })
                })
                .catch(error => {
                    console.log(error)
                    this.isLoading = false
                })
        },

        // π ----
        // :: CHECK IF THERE ARE ANYMORE ENTRIES ---------------------------::
        // ____
        anyMore() {
            const requestData = new FormData()
            const pageNumber = this.currentPage + 1

            requestData.append('action', 'blogFetch')
            requestData.append('page', pageNumber)
            requestData.append('per_page', this.perPage)

            // :: Filters ------------ //
            requestData.append('filter_category', this.filters.category.selected)
            requestData.append('filter_type', this.filters.type.selected)
            requestData.append('filter_sort', this.filters.sort.selected)
            if (this.search) {
                requestData.append('search_term', this.search)
            }
            if (this.isUnfiltered() && this.pinnedIds.length > 0) {
                requestData.append('exclude_ids', this.pinnedIds.join(','))
            }

            axios
                .post(this.api, requestData)
                .then(response => {
                    if (response.data.entries == '') {
                        this.finished = true
                    }
                })
                .catch(error => {
                    console.log(error)
                })
        },

        // π ----
        // :: UPDATE A SITE'S COLLECTION PAGE NUMBER ---------------------------::
        // ____
        updatePage() {
            this.currentPage += 1
        },

        // π ----
        // :: FILTER INIT ---------------------------::
        // ____
        filterInit() {
            /* :: Load Filters Based on Selected Collection
            {+} ---------------------------------- */
            this.fetchFilters('category')
            this.fetchFilters('type')
        },

        fetchFilters(taxonomy) {
            let filter

            if (taxonomy === 'category') {
                filter = this.filters.category.selections
            }
            if (taxonomy === 'type') {
                filter = this.filters.type.selections
            }

            const requestData = new FormData()
            requestData.append('taxonomy', taxonomy)
            requestData.append('action', 'blogTaxonomies')

            axios
                .post(this.api, requestData)
                .then(response => {
                    if (response.data) {
                        for (let i = 0; i < response.data.length; i++) {
                            if (response.data[i].name) {
                                filter.push(response.data[i])
                            }
                        }
                    } else {
                        console.log(`There was NO Taxonomy Response`)
                    }
                })
                .catch(error => {
                    console.log(error)
                })
        },

        isSelected(item) {
            const filter = this.filters.category.selected
            return filter.includes(item)
        },

        // π ----
        // :: FILTER COLLECTION ---------------------------::
        // ____
        /**
         * Once a filter is selected, we need to bind that slug to the appropriate _filter_.
         * Then re-fetch items the filters set through _fetchInit()_.
         */
        filterCollection(filterKey, filterSlug) {
            let newFilter
            let filter

            filter = this.filterCheck('category', filterKey, filterSlug, this.filters.category.selected)
            if (filter) {
                this.filters.category.selected = filter
                newFilter = true
                filter = false
            }

            if (filterKey === 'type') {
                if (this.filters.type.selected !== filterSlug) {
                    newFilter = true
                    this.filters.type.selected = filterSlug
                }
            } else if (filterKey === 'sort') {
                if (this.filters.sort.selected !== filterSlug) {
                    newFilter = true
                    this.filters.sort.selected = filterSlug
                }
            }

            if (newFilter) {
                this.updateResults()
            }
        },

        filterCheck(filterType, filterKey, filterSlug, filterSelected) {
            if (Array.isArray(filterType)) {
                if (!filterType.includes(filterKey)) {
                    return
                }
            } else {
                if (filterKey !== filterType) {
                    return
                }
            }

            if (filterSlug !== 'all') {
                filterSelected = Alpine.store('array').remove(filterSelected, 'all')
            } else {
                filterSelected = ['all']
            }

            if (!filterSelected.includes(filterSlug)) {
                filterSelected.push(filterSlug)
            } else if (filterSlug !== 'all') {
                filterSelected = Alpine.store('array').remove(filterSelected, filterSlug)
            }

            if (!filterSelected.length) {
                filterSelected = ['all']
            }

            return filterSelected
        },

        updateResults() {
            this.isLoading = true
            this.closeGrid(() => {
                this.resetCollection()
                this.filtered = true
                this.fetchEntries()
                this.pushUrlFilters()
            })
        },

        // π ----
        // :: SET URL FILTERS ---------------------------::
        // ____
        pushUrlFilters() {
            if (history.pushState) {
                const root = `${window.location.protocol}//${window.location.host}${window.location.pathname}?`
                let category = ''
                category = `category=${this.filters.category.selected}`
                let type = ''
                type = `type=${this.filters.type.selected}`
                let sort = ''
                sort = `sort=${this.filters.sort.selected}`
                const divider01 = category ? '&' : ''
                const divider02 = category && type ? '&' : ''
                const updatedURL = `${root}${category}${divider01}${type}${divider02}${sort}`
                window.history.pushState({ path: updatedURL }, '', updatedURL)
            }
        },

        // π ----
        // :: RESET ---------------------------::
        // ____
        resetCollection() {
            this.currentPage = 1
            this.finished = false
            this.items = []
        },
    }
}
